import React from 'react';
import Icon from '../../../components/AppIcon';

const WhatsAppBenefits = () => {
  const benefits = [
    {
      icon: "Zap",
      title: "Instant Responses",
      description: "Get immediate answers to your gaming queries with our lightning-fast WhatsApp support team available round the clock.",
      color: "var(--color-warning)"
    },
    {
      icon: "Target",
      title: "Personalized Recommendations",
      description: "Receive customized game suggestions based on your preferences, playing style, and winning potential analysis.",
      color: "var(--color-primary)"
    },
    {
      icon: "Gift",
      title: "Exclusive Offers",
      description: "Access VIP-only bonuses, special promotions, and exclusive gaming opportunities shared directly through WhatsApp.",
      color: "var(--color-accent)"
    },
    {
      icon: "Video",
      title: "Voice & Video Consultation",
      description: "Schedule one-on-one video calls with our gaming experts for detailed strategy discussions and personalized guidance.",
      color: "var(--color-success)"
    },
    {
      icon: "Lock",
      title: "Private & Secure",
      description: "All conversations are encrypted and confidential. Your gaming preferences and personal information remain completely secure.",
      color: "var(--color-text-secondary)"
    },
    {
      icon: "Smartphone",
      title: "Mobile-First Experience",
      description: "Seamlessly switch between text, voice notes, images, and video calls - all within the familiar WhatsApp interface.",
      color: "var(--color-primary)"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-surface-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-royal rounded-full flex items-center justify-center shadow-royal">
              <Icon name="MessageCircle" size={32} color="white" strokeWidth={2} />
            </div>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-gradient-royal mb-6">
            Why Choose WhatsApp?
          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Experience the future of gaming support with WhatsApp's powerful features designed specifically for premium players like you.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits?.map((benefit, index) => (
            <div 
              key={index}
              className="group bg-surface rounded-card p-8 shadow-subtle hover:shadow-royal transition-royal hover-lift"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-card bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center group-hover:shadow-glow transition-royal">
                    <Icon 
                      name={benefit?.icon} 
                      size={24} 
                      color={benefit?.color}
                      strokeWidth={2}
                    />
                  </div>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-xl font-heading font-semibold text-text-primary mb-3 group-hover:text-primary transition-royal">
                    {benefit?.title}
                  </h3>
                  
                  <p className="text-text-secondary leading-relaxed">
                    {benefit?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-primary/5 via-accent/5 to-primary/5 rounded-card p-8 border border-golden">
            <h3 className="text-2xl font-heading font-bold text-text-primary mb-4">
              Ready to Experience VIP Treatment?
            </h3>
            <p className="text-text-secondary mb-6 max-w-2xl mx-auto">
              Join thousands of satisfied players who trust Nitin's WhatsApp support for their gaming needs.
            </p>
            
            <div className="flex items-center justify-center space-x-6 text-sm text-text-muted">
              <div className="flex items-center space-x-2">
                <Icon name="Star" size={16} color="var(--color-warning)" />
                <span>4.9/5 Rating</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="MessageSquare" size={16} color="var(--color-success)" />
                <span>50K+ Conversations</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} color="var(--color-primary)" />
                <span>&lt; 2 Min Response</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsAppBenefits;